<template>
    <div>
        <v-row no-gutters>
            <v-btn small icon outlined color="primary" @click="$router.back()" class="mr-2">
                <v-icon>mdi-arrow-left</v-icon>
            </v-btn>

            <h3>{{ title }} Maintenance</h3>
        </v-row>

        <v-divider class="my-1"></v-divider>
    </div>
</template>

<script>
export default {
    props: {
        title: String
    }
}
</script>